import { Gtp } from 'src/app/shared/gtp';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import { ControlVelocidadService } from 'src/app/services/flota/control-velocidad-service/control-velocidad.service';
import { ControlParadas } from "../../../models/movil-control-paradas.model";

import { MatDialog } from '@angular/material/dialog';
import { MapaPopUpComponent } from 'src/app/shared/mapa/mapa-popup/mapa-popup.component';

@Component({
  selector: 'app-movilparadas',
  templateUrl: './movilparadas.component.html',
  styleUrls: ['./movilparadas.component.scss']
})

export class MovilParadasComponent implements OnInit {

  @Input() codequipo: any;
  @Input() descripcion: any;
  @Input() movildata: any;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  //pageEvent: PageEvent;

  public dataSource: MatTableDataSource<any>;
  public pageIndex: number = 0;
  public pageSize: number = 5;

  public filter: any = {
    desde : null,
    hasta : null,
    velocidad: 10,
    buscar: '',
    orderby: 'fecha_hora',
    sortby: 'asc',
    pageIndex: 0,
    pageSize: 5
  };
  public loading: boolean = false;
  public tableCount;
  public emptyData:boolean = true;

  displayedColumns: string[] = [
    'desde',
    'hasta',
    'calle',
    'puntocercano',
    // 'recorridopuntos',
    // 'recorridoacumulado',
    'duracion',
    'ver',
  ];

  constructor(
    // private gtp: Gtp,
    // private velocidad: ControlVelocidadService,
    public dialog: MatDialog
  ) {
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit() {
    // this.filter.desde = this.mdesde;
    // this.filter.hasta =this.mhasta;
    // this.filter.velocidad = this.mvelocidad;
    this.loadInformeInterno();
  }

    loadInformeInterno(){
    this.loading = true;
    this.loading = false;
    this.dataSource = new MatTableDataSource(this.movildata);
    this.dataSource.paginator = this.paginator;
    this.tableCount = this.dataSource.data.length;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    if(this.dataSource.data.length!=0){ this.emptyData = false; }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  /**
   * Funcion para setear los valores de los filtros en la tabla para poderlos filtrar por eso datos.
   */
  setFitro() {
    // this.filter.fdesde = this.fechaHoraDesde;
    // this.filter.fhasta = this.fechaHoraHasta;
    // this.filter.velocidad = this.velocidad;
  }

  setSort(event?) {
    this.filter.orderby = event.active;
    this.filter.sortby = event.direction;
    //this.loadInformeInterno();
  }

  setPagination(event?) {
    this.filter.pageIndex = parseInt(event.pageIndex);
    this.filter.pageSize = parseInt(event.pageSize);
    //this.loadInformeInterno();
    return event;
  }

  getPageSizeOptions(): number[] {
    return [5, 10, 20, this.tableCount];
  }

  getDurationClass(duracion: string): string {
    if (!duracion) return 'duration-short';

    const parts = duracion.split(':');
    const hours = parseInt(parts[0]) || 0;
    const minutes = parseInt(parts[1]) || 0;
    const totalMinutes = hours * 60 + minutes;

    if (totalMinutes < 30) {
      return 'duration-short'; // Parada corta (menos de 30 minutos)
    } else if (totalMinutes < 120) {
      return 'duration-medium'; // Parada media (30 minutos a 2 horas)
    } else {
      return 'duration-long'; // Parada larga (más de 2 horas)
    }
  }

    getVehicleStats(): any {
    let paradasCortas = 0;
    let paradasMedias = 0;
    let paradasLargas = 0;
    let tiempoTotalMinutos = 0;

    if (this.movildata && Array.isArray(this.movildata)) {
      this.movildata.forEach(parada => {
        if (parada && parada.duracion) {
          const parts = parada.duracion.split(':');
          const hours = parseInt(parts[0]) || 0;
          const minutes = parseInt(parts[1]) || 0;
          const totalMinutes = hours * 60 + minutes;

          tiempoTotalMinutos += totalMinutes;

          if (totalMinutes < 30) {
            paradasCortas++;
          } else if (totalMinutes < 120) {
            paradasMedias++;
          } else {
            paradasLargas++;
          }
        }
      });
    }

    // Convertir tiempo total a formato HH:MM:SS
    const horasTotal = Math.floor(tiempoTotalMinutos / 60);
    const minutosTotal = tiempoTotalMinutos % 60;
    const tiempoTotal = `${horasTotal.toString().padStart(2, '0')}:${minutosTotal.toString().padStart(2, '0')}:00`;

    return {
      paradasCortas,
      paradasMedias,
      paradasLargas,
      tiempoTotal
    };
  }

    getVehicleInfo(): any {
    // Obtener información adicional del primer elemento de paradas
    if (this.movildata && Array.isArray(this.movildata) && this.movildata.length > 0) {
      const firstParada = this.movildata[0];

      // Extraer marca si está disponible
      let marca = 'N/A';
      if (firstParada.marca && firstParada.marca.nom_marca) {
        marca = firstParada.marca.nom_marca;
      }

      // Extraer odómetro si está disponible
      let odometro = null;
      if (firstParada.odometro_total_mts) {
        const km = Math.round(firstParada.odometro_total_mts / 1000);
        odometro = `${km.toLocaleString()} km`;
      }

      return {
        marca,
        odometro
      };
    }

    return {
      marca: null,
      odometro: null
    };
  }



  verMapa(latitud, longitud, rotacion){
    this.dialog.open(MapaPopUpComponent, {
      data: {
        latitud: latitud,
        longitud: longitud,
        rotacion: parseFloat(rotacion)
      }
    });
  }

}
